import { Component, OnInit } from '@angular/core';
import { AppSecuredComponent } from 'src/app/app-secured/app-secured.component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styles: [
    ]
})
export class MenuComponent implements OnInit {

    model: any[] = [];
    envir = environment;

    constructor(
        public app: AppSecuredComponent,
    ) { }

    async ngOnInit(): Promise<any> {
        // const UserId = this.authService.getUserId();
        // const res = await this.pageService.getMenuByUser();
        // if (res.isSuccess){
        //     const data = res.data as PageModel[];
        //     data.map(x => {
        //         if (x.pageId == null){
        //             x.children = data.filter(y => y.pageId === x.id);
        //             this.model.push(x);
        //         }

        //     });
        // }
        this.model = [
            {
                label: 'Dashboard',
                img: 'assets/layout/images/topbar/dashboard.png',
                imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                routerLink: ['/']
            },
            {
                label: 'Quản lý nhân viên',
                img: 'assets/layout/images/topbar/dashboard.png',
                imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                routerLink: ['/core-general'],
                items: [
                    {
                        label: 'Tài khoản',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-general/users']
                    },
                    {
                        label: 'Chức vụ',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-general/roles']
                    },
                    {
                        label: 'Phân quyền',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-general/role-pages']
                    },
                    {
                        label: 'Nhóm nhân viên',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-general/core-user-relation']
                    },
                ]
            },
            {
                label: 'Quản lý địa danh',
                img: 'assets/layout/images/topbar/dashboard.png',
                imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                routerLink: ['/core-place'],
                items: [
                    {
                        label: 'Quản lý quốc gia',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-place/country']
                    },
                    {
                        label: 'Quản lý tỉnh thành',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-place/province']
                    },
                    {
                        label: 'Quản lý quận huyện',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-place/district']
                    },
                    {
                        label: 'Quản lý phường xã',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-place/ward']
                    },
                ]
            },
            {
                label: 'Quản lý hệ thống',
                img: 'assets/layout/images/topbar/dashboard.png',
                imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                routerLink: ['/core-hub'],
                items: [
                    {
                        label: 'Quản lý trung tâm',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-hub/hub']
                    },
                    {
                        label: 'Quản lý chi nhánh',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-hub/po-hub']
                    },
                    {
                        label: 'Quản lý bưu cục',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-hub/station-hub']
                    },
                    {
                        label: 'Phân khu vực phục vụ',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-hub/route-hub']
                    },
                    {
                        label: 'Phân tuyến giao nhận',
                        img: 'assets/layout/images/topbar/dashboard.png',
                        imgActive: 'assets/layout/images/topbar/dashboard_active.png',
                        routerLink: ['/core-hub/routing-hub']
                    },
                ]
            },
        ];
    }

    onMenuClick(): void {
        this.app.menuClick = true;
    }
}
